/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useSimpliCity } from "@simplicitycms/simplicity-common";
import { exists } from "cms/utils/empty-exists";
import { isNull } from "cms/utils/empty-exists";
import { isObject } from "cms/utils/empty-exists";
import { objectHasPropertyString } from "cms/utils/empty-exists";
import { Header } from "layout-components/header";
import { Footer } from "layout-components/footer";
import { Logger } from "cms/utils/logger";
import { DefaultError } from "layout/error/default-error";

const ErrorLayoutFullWidth = () => {
    const TAG = "[ErrorLayout]";
    const { error } = useSimpliCity();
    const wasNull = isNull(error);
    const didExist = exists(error);
    const wasErrorObject = isObject(error) && objectHasPropertyString(error, "message");
    const hasError = !wasNull && didExist && wasErrorObject;
    let displayedError = "";
    if (hasError) {
        Logger.warn(`${TAG} Error Occurred: ` + error?.message);
        Logger.warn(`${TAG} Error trace: ` + error?.trace);
        Logger.warn(`${TAG} Error stack: ` + error?.stack);
        Logger.error(error);
        displayedError = hasError ? JSON.stringify(error, null, 2) : "";
        // need to set model for Richtext component internals
        // setModel(errorModel)
    } else {
        return null;
    }
    const title = "Sorry, that page is no longer available";

    return (
        <Fragment>
            <Header />
            <div id="layout" className="layout">

                <div id="layout-fullwidth" className="layout-fullwidth layout-margins">

                    <div className="main-content">

                        {/* Title */}
                        <h1 className="page-title">{title}</h1>

                        <DefaultError />

                        <div>
                            {hasError &&
                                <details>
                                    <summary>
                                        <div style={{
                                            display: "flex", justifyContent: "flex-start", padding: "20px, 20px, 20px, 20px"
                                        }}
                                        >
                                            Error Details
                                        </div>
                                    </summary>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <div style={{
                                            border: "1px solid black",
                                            borderRadius: "8px",
                                            overflow: "auto",
                                            width: "100%",
                                            maxWidth: "1200px",
                                            // height: '600px',
                                            padding: "40px"
                                        }}
                                        >
                                            <pre style={{ width: "1000px" }}>
                                                {displayedError}
                                            </pre>
                                        </div>
                                    </div>
                                </details>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Fragment>
    );
};

ErrorLayoutFullWidth.displayName = "ErrorLayoutFullWidth";
export { ErrorLayoutFullWidth };

